import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { FiltersService } from 'src/app/services/filters.service';
import { InterfaceService } from 'src/app/services/interface.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { SmoothScrollService } from 'src/app/services/smooth-scroll.service';
import { NgxMasonryOptions } from 'ngx-masonry';

@Component({
  selector: 'app-paintings',
  templateUrl: './paintings.component.html',
  styleUrls: ['./paintings.component.scss'],
})
export class PaintingsComponent implements OnInit {
  @ViewChild('imageContainer') imageContainer: ElementRef;

  public masonryOptions: NgxMasonryOptions = {
    gutter: 64,
    // itemSelector: '.painting',
    // columnWidth: '.painting',
    // columnWidth: '.test',
    resize: true,
    initLayout: true,
    // fitWidth: true,
  };

  firstLoad = false;
  filterTriggered = false;

  collectionId = 'eues20009paintings';

  // This page filters by artist only, so its filter column depends on Artist
  // entities specifically - not on entities in general.
  readonly filterEntityTypes = ['Artist'];

  get hasEntityData() {
    return this.dataService.hasFilterableEntities(
      this.collectionId,
      this.filterEntityTypes
    );
  }

  get filterEntities() {
    return this.dataService.paintingsData.web_entities;
  }

  get currentLanguage() {
    return this.dataService.currentLanguage;
  }

  get generalTexts() {
    return this.dataService.generalTexts;
  }

  get artistsArr() {
    return Object.keys(this.artworkFilters.artist)
      .filter((id) => this.artworkFilters.artist[id]?.length > 0)
      .sort((a, b) => {
        const artistA = this.entityCache[a];
        const artistB = this.entityCache[b];
        const nameA = artistA?.surname?.[this.currentLanguage]?.trim()
          || artistA?.name?.[this.currentLanguage]?.trim() || '';
        const nameB = artistB?.surname?.[this.currentLanguage]?.trim()
          || artistB?.name?.[this.currentLanguage]?.trim() || '';
        return nameA.localeCompare(nameB, this.currentLanguage);
      });
  }

  getArtistFilterName(id: string): string {
    const artist = this.entityCache[id];
    return [
      artist?.surname?.[this.currentLanguage]?.trim(),
      artist?.name?.[this.currentLanguage]?.trim(),
    ]
      .filter(Boolean)
      .join(', ');
  }

  get artworkFilters() {
    return this.filters.artworkFilters;
  }

  get entityCache() {
    return this.dataService.entityCache;
  }

  get paintings() {
    if (
      this.dataService.paintingArtworks &&
      this.dataService.paintingArtworks.length
    ) {
      return this.dataService.paintingArtworks;
    } else {
      return [];
    }
  }

  constructor(
    public interfaceService: InterfaceService,
    public dataService: DataService,
    public filters: FiltersService,
    private router: Router,
    private smoothScroll: SmoothScrollService,
    private elementRef: ElementRef,
    private changeDetector: ChangeDetectorRef,
    private navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    this.interfaceService.displayDark = true;
    this.interfaceService.footerBackgroundChange = true;

    if (!this.navigationService.backBtnClicked) {
      this.filters.resetArtworkFilters();

      if (!this.paintings || !this.paintings.length) {
        this.dataService
          .fetchAllArtworks(this.collectionId, 'collection')
          .then((res) => {
            this.setFilters();
            this.firstLoad = false;

            // this.interfaceService.reveal();
            // console.log('FILTERS', this.filters.artworkFilters);
          });
      } else {
        this.setFilters();
        this.firstLoad = false;
        // this.interfaceService.reveal();
      }
    }

    this.interfaceService.reveal();
  }

  ngAfterViewChecked(): void {
    if (this.smoothScroll.scrollTarget && !this.firstLoad) {
      if (this.filters.savedFilteredArtworks.length) {
        this.filters.displayFilteredResults(
          (item) => this.toggleCheck(item),
          'paintings'
        );
        this.changeDetector.detectChanges();
        this.navigationService.backBtnClicked = false;
      } else {
        this.smoothScroll.scrollToId(this.smoothScroll.scrollTarget);
      }

      this.firstLoad = true;
    } else if (!this.firstLoad && this.paintings) {
      this.interfaceService.reveal();
      this.firstLoad = true;
    }
    if (this.filters.filterTriggered) {
      this.interfaceService.reveal();
      this.filters.filterTriggered = false;
    }
  }

  setFilters() {
    this.filterEntities.forEach((entity) => {
      this.filters.buildFilters(entity);
    });

    this.paintings.forEach((artwork) => {
      this.filters.storedFilters = [];

      artwork.entities?.forEach((entity) => {
        if (
          entity &&
          entity.customId &&
          this.filterEntityTypes.includes(entity.entityType)
        ) {
          this.filters.addArtworkToFilters(artwork, entity);
        }
      });
    });
    this.firstLoad = false;

    this.interfaceService.revealTimeout();
  }

  triggerCheck(item, e?, outerClick?) {
    this.filters.triggerCheckboxFilters(item, e);
  }

  toggleCheck(item) {
    return this.filters.toggleCheck(item);
  }

  storeScrollTarget(id: string) {
    this.smoothScroll.scrollTarget = id;
  }

  getCarouselMainImg(artworkId, mediaType) {
    return this.dataService.getMainMedia(artworkId, mediaType);
  }

  getFirstEntityName(artwork, property) {
    if (this.dataService.getEntityList(artwork, property)) {
      if (property === 'artist') {
        return this.getArtistFullName(artwork, property);
      } else {
        return this.dataService.getEntityList(artwork, property)[0].name;
      }
    } else {
      return null;
    }
  }

  getArtistFullName(artwork, property) {
    const artist = this.dataService.getEntityList(artwork, property)?.[0];
    const fullName = {};
    const languages = new Set([
      ...Object.keys(artist?.name ?? {}),
      ...Object.keys(artist?.surname ?? {}),
    ]);

    for (const language of languages) {
      fullName[language] = [
        artist?.name?.[language]?.trim(),
        artist?.surname?.[language]?.trim(),
      ]
        .filter(Boolean)
        .join(' ');
    }
    return fullName;
  }
}
